<div class="expandable-block-footer">
  <div class="expandable-block-footer__button">
    <brt-button [title]="title" [color]="'river'"></brt-button>
  </div>
</div>
